/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomFieldReference,
    CustomFieldReferenceFromJSON,
    CustomFieldReferenceFromJSONTyped,
    CustomFieldReferenceToJSON,
    JobReference,
    JobReferenceFromJSON,
    JobReferenceFromJSONTyped,
    JobReferenceToJSON,
    VolumeReference,
    VolumeReferenceFromJSON,
    VolumeReferenceFromJSONTyped,
    VolumeReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaRootDetailUpdate
 */
export interface MediaRootDetailUpdate {
    /**
     * 
     * @type {Array<CustomFieldReference>}
     * @memberof MediaRootDetailUpdate
     */
    customFields?: Array<CustomFieldReference>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaRootDetailUpdate
     */
    workflow?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {VolumeReference}
     * @memberof MediaRootDetailUpdate
     */
    volume: VolumeReference;
    /**
     * 
     * @type {Array<JobReference>}
     * @memberof MediaRootDetailUpdate
     */
    jobs?: Array<JobReference>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MediaRootDetailUpdate
     */
    aiConfig?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailUpdate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailUpdate
     */
    readonly path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    needsRescan?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailUpdate
     */
    viewMode?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailUpdate
     */
    viewStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailUpdate
     */
    viewDefaultTab?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showTags?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showComments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showCustomFields?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showRatings?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showSubclips?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showSubtitles?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showMarkers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showHistory?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    showAiMetadata?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    prefetchThumbnailStrips?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailUpdate
     */
    cover?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaRootDetailUpdate
     */
    nameField?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MediaRootDetailUpdate
     */
    shareComments?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailUpdate
     */
    shareLinkDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailUpdate
     */
    defaultProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailUpdate
     */
    cloudProxyProfile?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailUpdate
     */
    aiConnection?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MediaRootDetailUpdate
     */
    aiProxyProfile?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRootDetailUpdate
     */
    proxyProfiles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MediaRootDetailUpdate
     */
    tags?: Array<number>;
}

export function MediaRootDetailUpdateFromJSON(json: any): MediaRootDetailUpdate {
    return MediaRootDetailUpdateFromJSONTyped(json, false);
}

export function MediaRootDetailUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaRootDetailUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customFields': !exists(json, 'custom_fields') ? undefined : ((json['custom_fields'] as Array<any>).map(CustomFieldReferenceFromJSON)),
        'workflow': !exists(json, 'workflow') ? undefined : json['workflow'],
        'volume': VolumeReferenceFromJSON(json['volume']),
        'jobs': !exists(json, 'jobs') ? undefined : ((json['jobs'] as Array<any>).map(JobReferenceFromJSON)),
        'aiConfig': !exists(json, 'ai_config') ? undefined : json['ai_config'],
        'name': json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'needsRescan': !exists(json, 'needs_rescan') ? undefined : json['needs_rescan'],
        'viewMode': !exists(json, 'view_mode') ? undefined : json['view_mode'],
        'viewStyle': !exists(json, 'view_style') ? undefined : json['view_style'],
        'viewDefaultTab': !exists(json, 'view_default_tab') ? undefined : json['view_default_tab'],
        'showTags': !exists(json, 'show_tags') ? undefined : json['show_tags'],
        'showComments': !exists(json, 'show_comments') ? undefined : json['show_comments'],
        'showLocations': !exists(json, 'show_locations') ? undefined : json['show_locations'],
        'showCustomFields': !exists(json, 'show_custom_fields') ? undefined : json['show_custom_fields'],
        'showRatings': !exists(json, 'show_ratings') ? undefined : json['show_ratings'],
        'showSubclips': !exists(json, 'show_subclips') ? undefined : json['show_subclips'],
        'showSubtitles': !exists(json, 'show_subtitles') ? undefined : json['show_subtitles'],
        'showMarkers': !exists(json, 'show_markers') ? undefined : json['show_markers'],
        'showHistory': !exists(json, 'show_history') ? undefined : json['show_history'],
        'showAiMetadata': !exists(json, 'show_ai_metadata') ? undefined : json['show_ai_metadata'],
        'prefetchThumbnailStrips': !exists(json, 'prefetch_thumbnail_strips') ? undefined : json['prefetch_thumbnail_strips'],
        'cover': !exists(json, 'cover') ? undefined : json['cover'],
        'nameField': !exists(json, 'name_field') ? undefined : json['name_field'],
        'shareComments': !exists(json, 'share_comments') ? undefined : json['share_comments'],
        'shareLinkDuration': !exists(json, 'share_link_duration') ? undefined : json['share_link_duration'],
        'defaultProxyProfile': !exists(json, 'default_proxy_profile') ? undefined : json['default_proxy_profile'],
        'cloudProxyProfile': !exists(json, 'cloud_proxy_profile') ? undefined : json['cloud_proxy_profile'],
        'aiConnection': !exists(json, 'ai_connection') ? undefined : json['ai_connection'],
        'aiProxyProfile': !exists(json, 'ai_proxy_profile') ? undefined : json['ai_proxy_profile'],
        'proxyProfiles': !exists(json, 'proxy_profiles') ? undefined : json['proxy_profiles'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
    };
}

export function MediaRootDetailUpdateToJSON(value?: MediaRootDetailUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_fields': value.customFields === undefined ? undefined : ((value.customFields as Array<any>).map(CustomFieldReferenceToJSON)),
        'workflow': value.workflow,
        'volume': VolumeReferenceToJSON(value.volume),
        'jobs': value.jobs === undefined ? undefined : ((value.jobs as Array<any>).map(JobReferenceToJSON)),
        'ai_config': value.aiConfig,
        'name': value.name,
        'needs_rescan': value.needsRescan,
        'view_mode': value.viewMode,
        'view_style': value.viewStyle,
        'view_default_tab': value.viewDefaultTab,
        'show_tags': value.showTags,
        'show_comments': value.showComments,
        'show_locations': value.showLocations,
        'show_custom_fields': value.showCustomFields,
        'show_ratings': value.showRatings,
        'show_subclips': value.showSubclips,
        'show_subtitles': value.showSubtitles,
        'show_markers': value.showMarkers,
        'show_history': value.showHistory,
        'show_ai_metadata': value.showAiMetadata,
        'prefetch_thumbnail_strips': value.prefetchThumbnailStrips,
        'cover': value.cover,
        'name_field': value.nameField,
        'share_comments': value.shareComments,
        'share_link_duration': value.shareLinkDuration,
        'default_proxy_profile': value.defaultProxyProfile,
        'cloud_proxy_profile': value.cloudProxyProfile,
        'ai_connection': value.aiConnection,
        'ai_proxy_profile': value.aiProxyProfile,
        'proxy_profiles': value.proxyProfiles,
        'tags': value.tags,
    };
}


